import React from 'react';
import { Badge } from 'reactstrap';
import { KycStatus } from '../constants/kycConstants';

interface Props {
  status: string;
}

const KycStatusBadge: React.FC<Props> = ({ status }) => {
  switch (status) {
    case KycStatus.CREATED:
      return <Badge color="secondary">Creado</Badge>;
    case KycStatus.IN_PROGRESS:
      return <Badge color="info">En progreso</Badge>;
    case KycStatus.IN_REVIEW:
      return <Badge color="warning">En revisión</Badge>;
    case KycStatus.NEED_CUSTOMER_REVIEW:
      return <Badge color="primary">Revisión cliente</Badge>;
    case KycStatus.PARTIALLY_COMPLETED:
      return <Badge color="warning">Parcialmente completado</Badge>;
    case KycStatus.COMPLETED:
      return <Badge color="success">Completado</Badge>;
    case KycStatus.DISABLED:
      return <Badge color="danger">Deshabilitado</Badge>;
    default:
      return <Badge color="light">{status}</Badge>;
  }
};

export default KycStatusBadge;
